import React, { useState, useEffect } from 'react';
import { Card, Typography, CardContent, CardActions, Button, TextField } from '@mui/material';
import { Modal, Box } from "@mui/material";
import { Link } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';

const CustomCard = ({ title, buttons, footer, width = "800px", height = "auto", onClose, onButtonClick }) => {
  const buttonContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const buttonStyle = {
    background: "var(--bg-blue-green)",
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "5px",
    flex: "1",
    maxWidth: "200px",
    minWidth: "150px",
    textAlign: "center",
    textDecoration: "none",
    margin: "0 10px", // Add some spacing between buttons
  };

  return (
    <Card
      sx={{
        marginTop: "4vh",
        maxWidth: width,
        height: height,
        // backgroundColor: "rgba(242, 242, 242, 0.8)",
        position: "relative",
      }}
    >
      <CardContent>
        <h3 className="text-center text-custom fw-bold mb-3" style={{ color: "black" }}>
          {title}
        </h3>
        <div style={buttonContainerStyle}>
          {buttons.map((button, index) => (
            <React.Fragment key={index}>
              <div className="col-md-5 p-4 text-center text-dark fs-5 fw-bold">
                <Button
                  className="btn text-white fw-bold"
                  style={buttonStyle}
                  onClick={() => onButtonClick(button.text)} // Call onButtonClick with button text
                >
                  {button.text}
                </Button>
              </div>
              {index !== buttons.length - 1 && (
                <div
                  className="text-custom fw-bold mb-3 col-md-2 text-center"
                  style={{ color: "black", fontSize: "1.5rem" }}
                >
                  Or
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
        {footer && (
          <CardActions className="row" style={{ minHeight: "50px" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: "bold" }} align="center">
              {footer}
            </Typography>
          </CardActions>
        )}
       
      </CardContent>
    </Card>
  );
};

// const CardModal = ({ open, onClose, title, buttons, footer, width, height, onButtonClick }) => {
//   const modalStyle = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     // bgcolor: "transparent", 
//     // boxShadow: 24,
//     p: 4,
//     outline: "none",
//   };

//   return (
//     <Modal
//       open={open}
//       onClose={onClose}
//       aria-labelledby="modal-title"
//       aria-describedby="modal-description"
//     >
//       <Box sx={modalStyle}>
//         <CustomCard
//           title={title}
//           buttons={buttons}
//           footer={footer}
//           width={width}
//           height={height}
//           onClose={onClose}
//           onButtonClick={onButtonClick} // Pass the callback to handle button clicks
//         />
//       </Box>
//     </Modal>
//   );
// };
const CardModal = ({
  open,
  onClose,
  title,
  buttons,
  footer,
  width,
  height,
  onButtonClick,
  currentStep,
  number,
  onNumberChange,
  onNextStep,
}) => {
  console.log("CardModal rendering with open:", open, "Step:", currentStep); // Debug rendering

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: currentStep === 1 ? "rgba(242, 242, 242, 0.8)" : "",
    p: 4,
    outline: "none",
  };

  const renderContent = () => {
    if (currentStep === 1) {
      return (
        <TextField
          fullWidth
          label="Enter 11-digit Number"
          value={number}
          onChange={onNumberChange}
          inputProps={{ maxLength: 11 }}
          error={number.length > 0 && number.length !== 11}
          helperText={
            number.length > 0 && number.length !== 11
              ? "Please enter exactly 11 digits"
              : ""
          }
          variant="outlined"
          sx={{ mb: 2 }}
        />
      );
    } else if (currentStep === 2 || currentStep === 3) {
      return (
        <CustomCard
          title={title}
          buttons={buttons}
          footer={footer}
          width={width}
          height={height}
          onClose={onClose}
          onButtonClick={onButtonClick}
        />
      );
    }
    return null;
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={modalStyle}>
        {renderContent()}
        {currentStep === 1 && (
          <Button
            variant="contained"
            onClick={onNextStep}
            disabled={number.length !== 11}
            sx={{ mt: 2 }}
          >
            Next
          </Button>
        )}
      </Box>
    </Modal>
  );
};

export default CardModal;
